export const filters = () => {
  const filtersList = document.querySelector(".js-filters-list");
  const filterItems = document.querySelectorAll("[data-filter]");
  const items = document.querySelectorAll(".js-item-to-filter");

  const init = () => {
    if (filtersList) {
      let activeItem;
      const activeItemElement = filtersList.querySelector(".is-active");

      if (activeItemElement) {
        activeItem = activeItemElement;
        filterItemsByCategory(activeItem.getAttribute("data-filter"));
      } else {
        activeItem = filterItems[0];
        activeItem.classList.add("is-active");
        filterItemsByCategory(activeItem.getAttribute("data-filter"));
      }
    }

    bind();
  };

  const bind = () => {
    filterItems.forEach((item) => {
      item.addEventListener("click", function (evt) {
        evt.preventDefault();

        // Remove active class from all filter items
        filtersList.querySelector(".is-active")?.classList.remove("is-active");

        // Add active class to the clicked filter item
        this.classList.add("is-active");

        // Filter items based on the selected filter
        filterItemsByCategory(this.getAttribute("data-filter"));
      });
    });
  };

  const filterItemsByCategory = (filterValue) => {
    if (filterValue === "") {
      items.forEach((item) => {
        item.classList.remove("is-hidden");
      });
    } else {
      items.forEach((item) => {
        item.classList.add("is-hidden");
        if (item.getAttribute("data-category")?.includes(filterValue)) {
          item.classList.remove("is-hidden");
        }
      });
    }
  };

  if (filtersList) {
    init();
  }
};
